import React from 'react'

export const PageNotFound = () => {
    return (
        <>
            <h1>Page Not Found</h1>
            <a href="/">Click to return</a>
        </>
    )
}
